import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  selectCalendarEvents,
  selectRepeatingEvents,
  selectWorkspaces,
} from '../slices/workspaceSlice'
import { WorkspaceType } from '../../lib/db/db.types'

export const useCombinedCalendar = () => {
  const workspaces = useSelector(selectWorkspaces)

  const allCalendarEvents = useSelector(selectCalendarEvents)
  const allRepeatingEvents = useSelector(selectRepeatingEvents)

  const personalWorkspace = useMemo(
    () =>
      workspaces.find(
        (workspace) => workspace.spaceType === WorkspaceType.PERSONAL,
      ),
    [workspaces],
  )
  const personalWorkspaceId = personalWorkspace?.id

  const events = useMemo(() => {
    return [...Object.values(allCalendarEvents).flat()]
  }, [allCalendarEvents])

  const repeatingEvents = useMemo(() => {
    return [...Object.values(allRepeatingEvents).flat()]
  }, [allRepeatingEvents])

  const personalCalendarEvents = useMemo(
    () => (personalWorkspaceId ? allCalendarEvents[personalWorkspaceId] : []),
    [personalWorkspaceId, allCalendarEvents],
  )
  const personalRepeatingEvents = useMemo(
    () => (personalWorkspaceId ? allRepeatingEvents[personalWorkspaceId] : []),
    [personalWorkspaceId, allRepeatingEvents],
  )

  return {
    events,
    repeatingEvents,
    personalCalendarEvents,
    personalRepeatingEvents,
    personalCalendarName: personalWorkspace?.name ?? 'Personal',
  }
}
